<template>
  <CRow>
    <CCol md="12">
      <CCard>
        <CCardHeader>
          Επιθεωρητές - Υποθέσεις
        </CCardHeader>
        <CCardBody>
          <CRow>
            <CCol sm="12" lg="6" class="text-center">
              <CRow>
                <CCol sm="6">
                  <CCallout color="secondary">
                    <div @click="$router.push({ path: '/unscheduled-reports' })" style="cursor:pointer;">
                      <small class="text-muted">Απρογραμμάτιστες Υποθέσεις</small><br>
                      <strong class="h4">{{ this.unscheduledCases }}</strong>
                    </div>
                  </CCallout>
                </CCol>
                <CCol sm="6">
                  <CCallout color="info">
                    <div @click="$router.push({ path: '/scheduled-reports' })" style="cursor:pointer;">
                      <small class="text-muted">Προγραμματισμένες Υποθέσεις</small><br>
                      <strong class="h4">{{ this.scheduledCases }}</strong>
                    </div>
                  </CCallout>
                </CCol>
              </CRow>
            </CCol>
            <CCol sm="12" lg="6" class="text-center">
              <CRow>
                <CCol sm="6">
                  <CCallout color="warning">
                    <div @click="$router.push({ path: '/to-be-scheduled-reports' })" style="cursor:pointer;">
                      <small class="text-muted">Προς προγραμματισμό Υποθέσεις</small><br>
                      <strong class="h4">{{ this.toBeScheduledCases }}</strong>
                    </div>
                  </CCallout>
                </CCol>
                <CCol sm="6">
                  <CCallout color="success" >
                    <div @click="$router.push({ path: '/inspectors' })" style="cursor:pointer;">
                      <small class="text-muted">Επιθεωρητές</small><br>
                      <strong class="h4">{{ this.totalInspectors }}</strong>
                    </div>
                  </CCallout>
                </CCol>
              </CRow>
            </CCol>
          </CRow>
          <CDataTable
            class="mb-0 table-outline mt-3"
            id="dashboardInspectorsTable"
            hover
            :items="items"
            :fields="fields"
            head-color="light"
            no-sorting
            pagination
            :items-per-page="5"
            :loading="loading"
          >
            <template #avatar="{item}">
              <td class="text-center">
                <div class="c-avatar">
                  <img src="/user_avatar.png" class="c-avatar-img" alt="">
                  <span
                    class="c-avatar-status"
                    :class="getInspectorStatus(item.active)"
                  ></span>
                </div>
              </td>
            </template>
            <template #name="{item}">
              <td>
                {{ item.name }}
                <div class="small text-muted">Εγγράφηκε: {{ item.created_at.substring(0,10) | formatDate }}</div>
              </td>
            </template>
            <template #services="{item}">
              <td>
                {{ item.services }}
              </td>
            </template>
            <template #comments="{item}">
              <td>
                {{ getCommentsText(item.comments) }}
              </td>
            </template>
          </CDataTable>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import Vue from 'vue'
import moment from 'moment';

Vue.filter('formatDate', function(value) {
    if (value) {
        return moment(String(value)).format('DD/MM/YYYY')
    }
});

const fields = [
  { 
    key: 'avatar', 
    label: ''
  },
  { 
    key: 'name', 
    label: 'Ονοματεπώνυμο'
  },
  { 
    key: 'activity', 
    label: 'Δραστηριότητα'
  },
  { 
    key: 'services', 
    label: 'Πρότυπο ISO'
  },
  { 
    key: 'comments', 
    label: 'Σχόλια'
  }
]

export default {
  name: 'WidgetsDashboardInspectors',

  props: {
    statused: {
      type: Object,
      required: true
    },

    inspectors: {
      type: Array,
      required: true
    }
  },

  computed: {
    totalInspectors(){
      return this.inspectors.length.toString();
    }
  },

  data () {
    return {
      items: [],
      fields,
      currentPage: 1,
      perPage: 5,
      totalRows: 0,
      unscheduledCases: this.statused.unscheduledCases.value,
      toBeScheduledCases: this.statused.toBeScheduledCases.value,
      scheduledCases: this.statused.scheduledCases.value,
      loading: true,
    }
  },
  methods: {
    getCommentsText (comments) {
      if (!comments) {
        return '-';
      } else {
        return comments;
      }
    },
    getAllServices(services) {
      let temp = [];
      let text = '';
      temp = services.map((item) => {return item.name;});
      text = temp.join(", ");
      return text;
    },
    getInspectorStatus(status) {
      return status === 1 ? 'bg-success' : 'bg-secondary'
    },
    getInspectorsAndCases() {
      const completeItems = new Promise((resolve, reject) => {
        let items = this.inspectors.map((item) => {
          item.services = this.getAllServices(item.services);
          return item;
        })
        resolve(items)
      });

      completeItems
        .then(r => {
          this.items = r
          this.loading = false
        })
        .catch(e => console.log(e));
    },
  },
  mounted: function() {   
    this.getInspectorsAndCases();
  }
}
</script>
